export default __webpack_public_path__ + "static/media/288.4dd45767.png";